import apiClient from './client';

export async function uploadPayrollExcel(file: File): Promise<Blob> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/payroll/bulk-generate/', formData, {
    responseType: 'blob',
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data as Blob;
}

export interface PayrollImportItem {
  id: number;
  created_at: string;
  uploaded_by: string | null;
  total_rows: number;
  processed: boolean;
  batch_id: number | null;
  bulletin_count: number;
  zip_file: string | null;
  source_file?: string | null;
  source_filename?: string | null;
  display_name?: string;
}

export async function fetchPayrollImports(): Promise<PayrollImportItem[]> {
  const res = await apiClient.get('/payroll/imports/');
  return res.data.results as PayrollImportItem[];
}
